module.exports = __webpack_public_path__ + "static/speisekarte_helmarts-18ffebdf65cab8c70685df6a1700361f.pdf";